import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.search.js";
import Cookies from 'js-cookie';
/**
 * @description: 函数防抖，只执行最后一次操作
 * @param {type}
 * @return:
 */
export var debounce = function debounce(fn) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var timer = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn(args);
    }, time);
  };
};
/**
 * @description: 函数节流
 * @param {type}
 * @return:
 */
export var throttle = function throttle(fn) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var timer = null;
  var startTime = new Date();
  var curTime = new Date();
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    clearTimeout(timer);
    if (curTime - startTime >= time) {
      fn(args);
      startTime = curTime;
    } else {
      timer = setTimeout(function () {
        fn(args);
      }, time);
    }
  };
};
/**
 * @description: 入参map对象字典排序
 * @param {type}
 * @return:
 */
export var objKeySort = function objKeySort(obj) {
  var newKey = Object.keys(obj).sort();
  var newObj = {};
  for (var i = 0; i < newKey.length; i += 1) {
    ;
    newObj[newKey[i]] = obj[newKey[i]];
  }
  return newObj;
};
/**
 * @description: 存sessionStorage
 * @param {type}
 * @return:
 */
export var writeStorage = function writeStorage(key, val) {
  var value = val;
  if (value) {
    value = JSON.stringify(value);
  }
  sessionStorage.setItem(key, value);
};
/**
 * @description: 取sessionStorage
 * @param {type} key
 * @return: string
 */
export var readStorage = function readStorage(key) {
  var value = sessionStorage.getItem(key);
  if (value && value !== 'undefined') {
    return JSON.parse(value);
  }
  return null;
};
export var removeStorage = function removeStorage(key) {
  sessionStorage.removeItem(key);
};
export var writeCookie = function writeCookie(key, val) {
  var value = val;
  if (value) {
    value = JSON.stringify(value);
  }
  Cookies.set(key, value);
};
/**
 * @description: 取localstorage
 * @param {type} key
 * @return: string
 */
export var readCookie = function readCookie(key) {
  var value = Cookies.get(key);
  if (value && value !== 'undefined') {
    return JSON.parse(value);
  }
  return null;
};
/**
 * @description: 删除localstorage
 * @param {type} key
 * @return: string
 */
export var removeCookie = function removeCookie(key) {
  Cookies.remove(key);
};
var checkAddZone = function checkAddZone(num) {
  return num < 10 ? "0".concat(num.toString()) : num;
};
export var dateFormatter = function dateFormatter(nows) {
  if (!nows) return '';
  var now = new Date(nows);
  var year = now.getFullYear();
  var month = now.getMonth() + 1;
  month = checkAddZone(month);
  var date = now.getDate();
  date = checkAddZone(date);
  return "".concat(year, "-").concat(month, "-").concat(date);
};
export var dateTimeFormatter = function dateTimeFormatter(t) {
  var time = t;
  if (!time) return '';
  time = new Date(time).getTime();
  time = new Date(time);
  var year = time.getFullYear();
  var month = time.getMonth() + 1;
  month = checkAddZone(month);
  var date = time.getDate();
  date = checkAddZone(date);
  var hour = time.getHours();
  hour = checkAddZone(hour);
  var min = time.getMinutes();
  min = checkAddZone(min);
  var se = time.getSeconds();
  se = checkAddZone(se);
  return "".concat(year, "-").concat(month, "-").concat(date, " ").concat(hour, ":").concat(min, ":").concat(se);
};
// 时间戳转换为时分秒倒计时
export var countDown = function countDown(timestamp) {
  var timer = setInterval(function () {
    var nowTime = new Date();
    var endTime = new Date(timestamp * 1000);
    var t = endTime.getTime() - nowTime.getTime();
    var hours = Math.floor(t / 1000 / 60 / 60 % 24);
    var minutes = Math.floor(t / 1000 / 60 % 60);
    var seconds = Math.floor(t / 1000 % 60);
    var timehours = hours < 10 ? "0".concat(hours) : hours;
    var timeminutes = minutes < 10 ? "0".concat(minutes) : minutes;
    var timeseconds = seconds < 10 && seconds >= 1 ? "0".concat(seconds) : seconds;
    return "".concat(timehours, " :").concat(timeminutes, " :").concat(timeseconds);
  }, 1000);
};
export var secondToDate = function secondToDate(result) {
  var h = Math.floor(result / 3600) < 10 ? "0".concat(Math.floor(result / 3600)) : Math.floor(result / 3600);
  var m = Math.floor(result / 60 % 60) < 10 ? "0".concat(Math.floor(result / 60 % 60)) : Math.floor(result / 60 % 60);
  var s = Math.floor(result % 60) < 10 ? "0".concat(Math.floor(result % 60)) : Math.floor(result % 60);
  return "".concat(h, "\u65F6").concat(m, "\u5206").concat(s, "\u79D2");
};
export var secondToTime = function secondToTime(result) {
  var h = Math.floor(result / 3600) < 10 ? "0".concat(Math.floor(result / 3600)) : Math.floor(result / 3600);
  var m = Math.floor(result / 60 % 60) < 10 ? "0".concat(Math.floor(result / 60 % 60)) : Math.floor(result / 60 % 60);
  return "".concat(h, "\u65F6").concat(m, "\u5206");
};
// 获取url链接中指定参数
export var getQueryString = function getQueryString(name) {
  var reg = new RegExp("(^|&)".concat(name, "=([^&]*)(&|$)"), 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};
// 千分位加逗号
export var formatNum = function formatNum(value) {
  var newStr = '';
  var count = 0;
  for (var i = value.length - 1; i >= 0; i -= 1) {
    if (count % 3 === 0 && count !== 0) {
      newStr = "".concat(value.charAt(i), ",").concat(newStr);
    } else {
      newStr = value.charAt(i) + newStr;
    }
    // count++;
    count += 1;
  }
  // eslint-disable-next-line no-param-reassign
  value = newStr; // 自动补小数点后两位
  return value;
};